import React from "react";
import { Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import "./Our_Philosophy.css";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const philosophyData = [
  {
    id: 1,
    title: "High Germination",
   image: "/assets/images/home/our-philosophy/better_crop.jpeg",
    description:
      "Our premium-quality seeds are carefully selected to ensure high germination, giving your crops a healthy and productive start.",
  },
  {
    id: 2,
    title: "Better Crop ",
   
      image: "/assets/images/factory/img1.jpeg",
    description:
      "Grow stronger, healthier crops with seeds developed to maximize productivity and deliver higher yields every season.",
  },
  {
    id: 3,
    title: "Climate-Resilient",
    image: "/assets/images/home/our-philosophy/climate_resilence_1.jpeg",
    description:
      "Designed to perform in diverse weather conditions, our seeds help farmers achieve consistent growth and reliable harvests.",
  },
  {
    id: 4,
    title: "Sustainable Farming",
    image: "/assets/images/home/our-philosophy/sustainable_farming.jpeg",
    description:
      "Support eco-friendly agriculture with quality seeds that promote healthier soil, sustainable farming, and long-term success.",
  },
];

const Our_Philosophy = () => {
  return (
<section className="our_philosophy">
  <div className="container">

    <Common_Title_2
      titleText="Our Farming Philosophy"
      subText="Quality Products, Sustainable Growth."
      simpleText="Growing Success Together."
    />

    {/* <Row className="g-4 philosophy_cards">
      {philosophyData.map((item) => (
        <Col lg={3} md={6} sm={6} xs={12} key={item.id}>
          <div className="philosophy_card">

            <div className="icon_box">
              <img src={item.image} alt={item.title} />
            </div>

            <h3>{item.title}</h3>

            <p>{item.description}</p>

          </div>
        </Col>
      ))}
    </Row> */}
    <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={25}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        >
          {philosophyData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="philosophy_card">
                <div className="icon_box">
                  <img src={item.image} alt={item.title} />
                </div>

                <h3>{item.title}</h3>

                <p>{item.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

  </div>
</section>
  );
};

export default Our_Philosophy;
